function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 18.856a8 8 0 100-16 8 8 0 000 16zM9 1.448v1.408M7.08 1h3.84M8.968 6.056v4.736M13 10.792H8.968",
  stroke: "#70544F",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTimer;